import { PayloadAction } from '@reduxjs/toolkit';
import { message } from 'antd';
import {
  UploadScorePayload,
  UploadScoreResponse,
} from 'features/Yucollect/UploadScore/uploadScore.type';
import { put, takeLatest } from 'redux-saga/effects';
import {
  uploadScoreFailure,
  uploadScoreReq,
  uploadScoreSuccess,
} from 'redux/slice/score/UploadScore.slice';
import { scoreEndpoints } from 'services/api/endPoints';
import { HTTPClient } from 'services/api/http-client';

function* uploadScoreSaga({ payload }: PayloadAction<UploadScorePayload>) {
  try {
    const { agencyId, formData } = payload;
    const result: { data: UploadScoreResponse; status: number } =
      yield HTTPClient.PostRequest(
        scoreEndpoints.UPLOAD_SCORE_FILE(agencyId),
        formData
      );
    if (result?.status === 200) {
      yield put(uploadScoreSuccess(result.data.data));
    } else {
      yield put(uploadScoreFailure('Failed to upload score file'));
      message.error('Failed to upload score file');
    }
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || 'Failed to upload score file';
    yield put(uploadScoreFailure(errorMsg));
    message.error(errorMsg);
  }
}

export function* watchUploadScoreSagas() {
  yield takeLatest(uploadScoreReq.type, uploadScoreSaga);
}
